import React, { memo, useMemo } from 'react';
import { Controller } from 'react-hook-form';
import MultiSelect, { MultiSelectItem } from '../../molecules/MultiSelect';
import { EvaluationFieldProps } from '../../types/Evaluation';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(.5, 2),
  },
  fieldLabel: {
    flexShrink: 0,
    width: 160,
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.text.primary,
    fontWeight: 600,
  },
}), { name: 'MultiSelectInput' }); 

function MultiSelectInput({ name, control, label, selectionMessage = 'Select...', options = [] }: EvaluationFieldProps) {
  const items: MultiSelectItem[] = useMemo(
    () => options.map(opt => ({ value: opt, content: opt })),
    [options],
  );
  const classes = useStyles();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, onBlur } }) => (
        <Box className={classes.inputWrapper}>
            <Box className={classes.fieldLabel}>{label}:</Box>
            <MultiSelect
            items={items}
            values={Array.isArray(value) ? value : []}
            labelWhenSelectedNone={selectionMessage}
            onChange={onChange}
            onBlur={onBlur}
            />
        </Box>
      )}
    />
  );
}

export default memo(MultiSelectInput);
